import React from "react";
import {
  Pulse, Command, Activity, CalendarBlank, Funnel, ChartLineUp,
  Books, ListMagnifyingGlass, CheckSquare, Robot, Toolbox, Handshake,
  TrendUp, Coins, Broadcast, Globe, GlobeHemisphereWest,
  HardDrives, Brain, Gear, UsersThree, Scales,
} from "@phosphor-icons/react";

export const SECTIONS = [
  {
    group: "OPERATE",
    items: [
      { id: "command",     label: "Common Operating Picture", icon: Command,       active: true },
      { id: "today",       label: "Today",               icon: CalendarBlank },
      { id: "opportunities", label: "Opportunities",     icon: Funnel },
      { id: "scorecard",   label: "Scorecard (OaaS)",    icon: ChartLineUp },
      { id: "decisions",   label: "Decision Queue",      icon: Scales },
      { id: "negotiations", label: "Negotiations · In Flight", icon: Broadcast },
      { id: "learning",    label: "Retrospectives",      icon: Books },
      { id: "audit",       label: "Audit Trail",         icon: ListMagnifyingGlass },
      { id: "approvals",   label: "Approvals",           icon: CheckSquare },
      { id: "agents",      label: "System of Agents",    icon: Robot },
      { id: "tools",       label: "Methods & Tools",     icon: Toolbox },
      { id: "simulator",   label: "Strategy Multiplier", icon: Handshake },
    ],
  },
  {
    group: "MARKET",
    items: [
      { id: "mop",         label: "Market Operating Picture", icon: GlobeHemisphereWest },
    ],
  },
  {
    group: "PLATFORM",
    items: [
      { id: "collectors",  label: "Collectors",          icon: HardDrives },
      { id: "analyst",     label: "AI Analyst",          icon: Brain },
      { id: "team",        label: "Team Management",     icon: UsersThree },
      { id: "system",      label: "System",              icon: Gear },
    ],
  },
];

// Flat list (used by Command Palette navigation matching)
export const ALL_SECTIONS = SECTIONS.flatMap((g) =>
  g.items.map((it) => ({ ...it, group: g.group }))
);

export const ALL_SECTION_IDS = ALL_SECTIONS.map((s) => s.id);
